import React from 'react'
import { ReactComponent as Flows } from '../../assets/ic_inspections.svg';

const InspectionsIcon = () => <Flows />;

export default InspectionsIcon;